import {useState} from "react";
import axios from "axios";

const useLsLight = ({zoneNo}: {zoneNo: number}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<
        | {
              no: number;
              zoneNo: number;
              wgId: string;
              id: string;
              lineNo: string;
              lineName: string;
              lineNumber: string;
              lineType: string;
              name: string;
              subNo: string;
              isOutdoor: boolean;
              order: number;
          }[]
        | null
    >(null);

    const getLightList = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_LS_API_URL}/lights/${zoneNo}`);
            if (res.data) setResponse(res.data.lines);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    return {lightList: response, lightLoading: loading, getLightList};
};

export {useLsLight};
